import { AxiosResponse } from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import {
  LatestTermsResponse,
  TermsProgramCode,
} from "../models/latest-terms-response.model";
import { createAxiosInstance } from "../utils/axios-instance";

const unwrapLatestTermsResponse = (
  response: AxiosResponse<LatestTermsResponse | { data: LatestTermsResponse }>
): LatestTermsResponse => {
  const responseBody = response.data;
  const unwrappedResponse =
    responseBody && typeof responseBody === "object" && "data" in responseBody
      ? responseBody.data
      : responseBody;

  if (!unwrappedResponse || !unwrappedResponse.contentHtml) {
    throw new Error("Failed to load terms and conditions.");
  }

  return unwrappedResponse;
};

export const getLatestTerms = async (
  programCode: TermsProgramCode,
  msalInstance: IPublicClientApplication
): Promise<LatestTermsResponse> => {
  const axiosInstance = createAxiosInstance(msalInstance);
  const response = await axiosInstance.get<
    LatestTermsResponse | { data: LatestTermsResponse }
  >(
    `${process.env.REACT_APP_INVITE_API_URL}/termsandconditions/${programCode}/latest`
  );

  return unwrapLatestTermsResponse(response);
};
